export default "__VITE_ASSET__Dov64lEv__"